module.exports = __webpack_public_path__ + "static/img/defaultImg.d45df20b.jpeg";